import { t } from "@lingui/core/macro";
import { notifications } from "@mantine/notifications";
import { isNoPermission } from "./apiErrorCodes";

/**
 * @typedef {Object} ApiResponse
 * @property {*} response
 * @property {boolean} isError
 */

/**
 * @param {Object} params
 * @param {string} params.id
 * @param {ApiResponse} params.apiResponse
 * @param {string} [params.successTitle]
 * @param {string} [params.successMessage]
 * @param {function} [params.onSuccess]
 *
 * @example
 *  const apiResponse = await fnc();
 *
 *	handleApiResponse({
 *		id: "register",
 *		apiResponse: apiResponse,
 *		successTitle: t`Cuenta creada con éxito`,
 * 		onSuccess: () => {},
 *	});
 */
export function handleApiResponse({
	id,
	apiResponse = { response: null, isError: false },
	successTitle,
	successMessage,
	onSuccess = () => {},
}) {
	if (apiResponse?.isError) {
		notifications.show({
			id: id,
			title: t`Error`,
			message:
				(isNoPermission(apiResponse?.response)
					&& t`No tienes permisos para realizar esta acción`)
				|| apiResponse?.response?.message
				|| apiResponse?.response?.errorCode
				|| apiResponse?.response?.errorId
				|| t`Ha ocurrido un error desconocido`,
			color: "red",
		});
	} else {
		if (successTitle) {
			notifications.show({
				id: id,
				title: successTitle,
				message: successMessage,
				color: "green",
			});
		}

		onSuccess({ response: apiResponse?.response });
	}
}
